/**
 * Утилиты для определения типа устройства и оптимизации интерфейса
 */

/**
 * Определяет, использует ли пользователь мобильное устройство
 * @returns {boolean} true, если устройство мобильное
 */
export const isMobile = () => {
  if (typeof window === 'undefined') return false;
  
  // Проверка через User Agent
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
    return true;
  }
  
  // Проверка через размеры экрана
  return window.innerWidth < 768;
};

/**
 * Определяет, использует ли пользователь планшет
 * @returns {boolean} true, если устройство планшет
 */
export const isTablet = () => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent;
  // Проверка для iPad
  const isIpad = /ipad/i.test(userAgent) || 
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  
  // Общая проверка для планшетов
  const isOtherTablet = /tablet/i.test(userAgent) && !/mobile/i.test(userAgent);
  
  // Проверка через размеры экрана (обычно 768-1024px для планшетов)
  const isTabletBySize = window.innerWidth >= 768 && window.innerWidth <= 1024;
  
  return isIpad || isOtherTablet || isTabletBySize;
};

/**
 * Определяет тип устройства пользователя
 * @returns {string} тип устройства ('mobile', 'tablet', 'desktop')
 */
export const getDeviceType = () => {
  if (isMobile() && !isTablet()) return 'mobile';
  if (isTablet()) return 'tablet';
  return 'desktop';
};

/**
 * Определяет, использует ли пользователь iOS-устройство
 * @returns {boolean} true, если устройство на iOS
 */
export const isIOS = () => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iphone|ipad|ipod/i.test(userAgent) && !window.MSStream;
};

/**
 * Определяет, использует ли пользователь устройство Android
 * @returns {boolean} true, если устройство на Android
 */
export const isAndroid = () => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android/i.test(userAgent);
};

/**
 * Определяет, использует ли пользователь сенсорный экран
 * @returns {boolean} true, если устройство имеет сенсорный экран
 */
export const isTouchDevice = () => {
  if (typeof window === 'undefined') return false;
  
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
};

/**
 * Получает информацию об ориентации устройства
 * @returns {string} ориентация ('portrait' или 'landscape')
 */
export const getOrientation = () => {
  if (typeof window === 'undefined') return 'portrait';
  
  return window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
};

/**
 * Добавляет классы для определения типа устройства в HTML-элемент
 * Это полезно для CSS-стилей, специфичных для разных устройств
 */
export const addDeviceClasses = () => {
  if (typeof document === 'undefined') return;
  
  const html = document.documentElement;
  const deviceType = getDeviceType();
  const orientation = getOrientation();
  
  // Удаляем предыдущие классы
  html.classList.remove('mobile', 'tablet', 'desktop', 'portrait', 'landscape', 'ios', 'android');
  
  // Добавляем актуальные классы
  html.classList.add(deviceType);
  html.classList.add(orientation);
  
  if (isIOS()) html.classList.add('ios');
  if (isAndroid()) html.classList.add('android');
  if (isTouchDevice()) html.classList.add('touch-device');
};
